import { Button, CircularProgress } from '@mui/material';

type SaveButtonProps = {
    submitHandler: React.MouseEventHandler<HTMLButtonElement>;
    isLoading?: boolean;
    text?: string;
    isDisabled?: boolean;
};

export default function SaveButton({ submitHandler, isLoading = false, text = 'Save', isDisabled }: SaveButtonProps) {
    return (
        <Button
            id={text}
            sx={{
                minWidth: '8rem',
                backgroundColor: 'secondary.main',
                color: 'black',

                '&:hover': {
                    backgroundColor: 'secondary.light',
                    color: 'black',
                },
            }}
            variant='contained'
            onClick={submitHandler}
            disabled={isLoading || isDisabled}
        >
            {isLoading ? <CircularProgress size={30} /> : text}
        </Button>
    );
}
